export default __webpack_public_path__ + "static/media/success.490ef94a.svg";